/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IConfigurationModel, useHomeUrl } from "@nf/common";
import { captureMessage } from "@sentry/nextjs";
import { useTranslation } from "next-i18next";
import { useEffect } from "react";

import Button from "components/Button";

import styles from "./PageNotFound.module.scss";

export interface PageNotFoundProps {
  referer?: string;
  configuration?: IConfigurationModel;
}

export const PageNotFound = ({ referer, configuration }: PageNotFoundProps) => {
  const { t } = useTranslation("translations");
  const homeUrl = useHomeUrl(configuration);

  useEffect(() => {
    captureMessage("404 page", {
      level: "info",
      tags: {
        status_code: 404,
      },
      extra: {
        previous_route: referer ?? "direct",
      },
    });
  }, []);

  return (
    <div className={styles.containerContent}>
      <h1 className={styles.notFound}>404 - {t("web_page_not_found")}</h1>
      <p className={styles.errorText}>{t("web_page_not_found_info")}</p>
      <Button
        size="medium"
        variant="primary"
        href={homeUrl}
        className={styles.button}
      >
        {t("web_page_not_found_button")}
      </Button>
    </div>
  );
};

export default PageNotFound;
